import { ProjectBackupListResponse, ServiceStackBackupResponse } from '@zerops/models/service-stack';
import { HashMap } from '@zerops/zef/core';

export class ServiceStackBaseState {
  containerFiles: HashMap<HashMap<string>>;
  backups: HashMap<ServiceStackBackupResponse>;
  projectBackups: HashMap<ProjectBackupListResponse & { sort?: string[]; offset?: number; }>;

  constructor() {
    this.containerFiles = undefined;
    this.backups = {};
    this.projectBackups = {};
  }
}

export class ContainerFilesAccess {
  accessToken: string;
  expiration: string;
  listUrl: string;
  readFileContentUrl: string;
  readFileUrl: string;
}

export class ContainerFile {
  size: number;
  content: string;
  mimeType: string;
}
